// extracted by mini-css-extract-plugin
module.exports = {"opening":"Opening_opening__2D-ct","content":"Opening_content__1xJuS"};